import Vue from 'vue'
import VueRouter from 'vue-router'
import HomePage from '../modules/FrontPage/HomePage.vue'
import Sapp from '../modules/FrontPage/Sapp.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomePage
  },
  {
    path: '/fsa',
    name: 'fsa',
    component: Sapp
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
